<a href="javascript:;" (click)="downloadFile()">{{
  'Conversation::ClickHereToDownloadListReport' | abpLocalization
}}</a>
